import AdminAccess from './AdminAccess'
import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { Alert } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import AdminLayout from './AdminLayout'
import Directory from './Directory'
import Offers, { OfferDetail } from './Offers'
import Detail from './Detail'
import Credits from './Credits'
import Coupons from './Coupons'
import Reports from './Reports'
import Overview from './Overview'
import Notifications from './Notifications'
import Admissions from './Admissions'
export default function Admin() {
  return <AdminAccess><LocalizationProvider dateAdapter={AdapterMoment}><AdminLayout>
      <Routes><Route index element={<Overview />} /><Route path="users" element={<Directory kind="users" />} /><Route path="users/:id" element={<Detail kind="users" />} />
        <Route path="businesses" element={<Directory kind="businesses" />} /><Route path="businesses/:id" element={<Detail kind="businesses" />} />
        <Route path="offers" element={<Offers />} /><Route path="offers/:id" element={<OfferDetail />} /><Route path="credits" element={<Credits />} /><Route path="coupons" element={<Coupons />} />
        <Route path="reports" element={<Navigate replace to="/admin/reports/overview" />} /><Route path="reports/:section" element={<Reports />} /><Route path="notifications" element={<Notifications />} />
        <Route path="admission" element={<Admissions />} />
        <Route path="*" element={<Alert severity="info">This Admin page is not available.</Alert>} /></Routes>
    </AdminLayout></LocalizationProvider></AdminAccess>
}
